<template>
  <div class="main">
    <b-row>
      <div v-loading="loading" class="chart-form">
        <el-form ref="this" :inline="true" :model="this">
          <el-form-item label="Default Reporting Currency:">
            <!--<el-select v-model="currencyCode" placeholder="select program type">
              <el-option v-for="item in this.programType" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>-->
            <el-select v-model="currencyId" placeholder="select Currency">
              <el-option v-for="item in this.defaultCurrencies" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Default Lender:">
          <el-select v-model="lenderId" style = "width: 140px;">
              <el-option v-for="item in this.lenders" :key="item.id" :label="item.lenderCode" :value="item.id"></el-option>
          </el-select>
          </el-form-item>
        </el-form>
      </div>
    </b-row>
    <b-row>
      <div style="margin-top:10px;" />
      <div v-loading="loading">
        <el-button size="small" type="primary" style="margin-left :545px; font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="onSubmit">Submit</el-button>
        <el-button size="small" type="primary" style="margin-left :5px; font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="cancel">Cancel</el-button>
      </div>
    </b-row>
  </div>
</template>

<script>
import * as cognosLaunch from '../utils/cognoslaunch.js';
import HTTP_API from '@/utils/http-api'

export default {
  data() {
    return {
      lenderId:'',
      currentLenderId:'',
      currencyCode: '',
      currencyId: '',
      currentCurrencyId: '',
      lenders:[],
      defaultCurrencies:[],
      loading: false
    }
  },
  methods:{
    cancel(){
      this.$router.push({ name: "home",params: {lenderId: this.lenderId}});
    },
    onSubmit() {
      var vm = this
      var updateRequired = false;
      var lenderIdUpdated = false;

      if(!(vm.currencyId === vm.currentCurrencyId)){
        updateRequired = true;
      }

      if(!(parseInt(vm.currentLenderId) === parseInt(vm.lenderId))){
        updateRequired = true;
        lenderIdUpdated = true;		
      }
      
      if(updateRequired){				
        var paramSet = {};
        paramSet.defaultLender = vm.lenderId;
        paramSet.defaultReportCurr = vm.currencyId
        HTTP_API.post('/settings/updateaccountsettings/', paramSet)
        .then(response => {
          
          if(lenderIdUpdated){		
            vm.lenderId = response.data.defaultLender

            //Logging off from Cognos:
            cognosLaunch.logoffCognos();

            setTimeout(() => {
              window.location.href = "/CR/home/" + vm.lenderId;
            }, 1000)
          
          } else{
              vm.$router.push({ name: "home",params: {lenderId: vm.lenderId}});
          }
        })
        .catch(function (error) {
          console.log(error.response)
        })

        

      } else {
        vm.$router.push({ name: "home",params: {lenderId: vm.lenderId}});	
      }
    },
    resetAllFlag() {
      this.loading = false
    },
    getAccountSettingsData(){
      var vm = this
      vm.loading=true;
      HTTP_API.get('/settings/accountsettingsdashboard')
      .then(response => {
        vm.lenderId = response.data.lenderId
        vm.currentLenderId = response.data.lenderId
        vm.currencyId = response.data.prefReportingCurrId
        vm.currentCurrencyId = response.data.prefReportingCurrId
        vm.lenders = response.data.lenders
        vm.defaultCurrencies = response.data.defaultCurrencies

        vm.resetAllFlag();
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    }
  },
  created() {
    this.getAccountSettingsData();
	}
}
</script>

<style scoped>
  .button_bottom_right-form {
  float: right;
  width: 300px;
  border: 3px solid #73AD21;
  padding: 10px;
    }
  .chart-form {
    border-radius: 5px;
    margin-left: 7px;
    padding: 5px 5px 5px 5px;
    /* background: rgba(255, 255, 255, .9); */
    background: #f2f2f2;
    opacity: 0.96;
    border: 2px solid #7cc1eb;
    width: 700px;
  }
  .el-form-item {
    padding: 0;
    margin: 0;
  }
  .main{
  }
  /*
	 * #frame1, #frame2, #frame3, #frame4{ margin: 12px 0px 5px 0px; border:
	 * 1.5px solid silver; box-shadow: 0 0 5px silver; }
	 */
  .borderClass{
    margin: 12px 0px 5px 0px;
    border: 1.5px solid silver;
    box-shadow: 0 0 5px silver;
  }
</style>